export default {
  "text": "_text_9jguwc",
  "selected-text": "_selected-text_9jguwc",
  "placeholder": "_placeholder_9jguwc",
  "clear-btn": "_clear-btn_9jguwc",
  "secondary": "_secondary_9jguwc",
  "selected-icon": "_selected-icon_9jguwc"
};